import React, { Component } from 'react'
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { 
  Button,FormGroup,Checkbox,
  Intent, Spinner, RadioGroup, Radio
} from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import { bookingReference } from 'helpers/bookingReference';
import BookingClientJob, { bookingJob, isRecurringBooking } from 'components/Booking/BookingClientJob';
import BookingCardPayments from 'components/Booking/BookingCardPayments';
import * as DataList from 'components/DataList';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import DateTimeInput from 'components/DateTimeInput';
import moment from 'moment';
import GeoComplete from '../../helpers/GeoComplete';
import { currencyFormattedAmount } from 'helpers/currency';
import ShareBookingLink from 'components/Booking/ShareBookingLink';
import QuestionRadio from 'components/Booking/QuestionRadio';
import QuestionSelect from 'components/Booking/QuestionSelect';
import QuestionTextbox from 'components/Booking/QuestionTextbox';
import { hasGroupedQuestions,
  BookingPageHeader, BookingSection, BookingTicket, BookingAttachments,
  ServiceTypeSelectWrap, joinAddress
} from 'components/Booking/BookingLayout';
import { normalizeHex } from 'helpers/serviceTypeColor';
import { flatOptionLabel, flatOptionQuantity } from 'helpers/bookingPricing';

var startCountRange = 0;
var label= '';
var indexChecked = '';
var selectedAnswer = '';


const items=[ 
  { label: 'Cash', value: 'Cash' }, 
  { label: 'Interac', value: 'Interac' },
  { label: 'Cheque', value: 'Cheque' },
  { label: 'Debit/Credit', value: 'dr/cr' }
];

@inject('store','bookingStore','serviceTypeStore','pricingParameterStore','frequencyStore','serviceAgreementStore','jobStore','questionGroupStore','serviceTypeCategoryStore','viewStore') @observer
class BookingShowPage extends Component {
  @observable pricingParameterArray = [];

  constructor(props) {
    super(props);
    this.state = {
      isServiceTypeChecked: 0,
      isPaymentSelect:0,
      isFrequencySelected: null
    };
  }

  @observable startCountRange = 0;
  @observable extra_service_total = 0;
  @observable pricing_parameter_total = 0;
  @observable pricing_range_total = 0;
  @observable isServiceExtraChecked = 0;
  @observable grand_total = 0.0;

  componentDidMount() {
    let {
      questionGroupStore,
      serviceTypeStore,
      serviceTypeCategoryStore,
      bookingStore:{
        booking:{
          object
        }
      }
    } = this.props;
    if(object && object.attributes){
      this.grand_total = object.attributes.total;
    }
    serviceTypeCategoryStore.loadServiceTypeCategories();
    serviceTypeStore.loadServiceTypesBooking();
    questionGroupStore.loadQuestionGroups();
  }

  startEditJob(job,booking_id) {
    let params = {
      uuid: job.id
    }
    
    this.props.jobStore.loadJobForBooking(params).then((result) => {
      // The id can already match a job left on screen. Open the dialog only
      // when this fetch itself wrote the store.
      if (!result.applied) return;
      const storeJob = this.props.jobStore.job;
      this.props.jobStore.persistJob = {
        object: {
          ...storeJob,
          id: storeJob.object.attributes.id,
          start_date: moment(storeJob.object.attributes.start_date),
          end_date: moment(storeJob.object.attributes.end_date),
          isServiceAgreement: true,
          title: storeJob.object.attributes.title,
          po_number: storeJob.object.attributes.po_number,
          reason_for_call: storeJob.object.attributes.reason_for_call,
          //service_agreement_id: serviceAgreement.object.id,
          location_id: storeJob.object.attributes.location_id,
          location: {
            attributes: {
              ...storeJob.object.attributes.location,
              name: storeJob.object.attributes.location.full_address
            }
          },
          client: {
            attributes: storeJob.object.attributes.client
          },
          selectedServiceType: [
            {
              value: storeJob.object.attributes.service_type_id, 
              selected: true, 
              label: storeJob.object.attributes.service_type_name
            }
          ]
        }
      }
      this.props.store.isOpen = true;

    })


    
  }

  startEditServiceAgreement(id,booking_id) {
    let {
      serviceAgreementStore
    } = this.props;
    let params = {
      uuid: id
    }
    serviceAgreementStore.loadServiceAgreementForBooking(params).then(response => {
      let {
        serviceAgreementStore: {
          serviceAgreement: {
            object
          }
        }
      } = this.props;
      this.props.serviceAgreementStore.persistServiceAgreement = {
        object: {
          ...object.attributes,
          start_time: moment(object.attributes.start_time).toDate(),
          end_time: moment(object.attributes.end_time).toDate(),
          locations: [{
            attributes: {
              id: object.attributes.location.id,
              full_address: object.attributes.location.full_address,
              name: object.attributes.location.full_address,
              client_id: object.attributes.client_id,
              
            }
          }],
          selectedServiceType: [
            {
              label: object.attributes.service_type.name,
              value: object.attributes.service_type.id,
              selected: true
            }
          ],
          client: {
            attributes: object.attributes.client
          },
          booking_id: booking_id
        }
      }
      this.props.jobStore.isServiceAgreement = true;
      this.props.store.isOpen = true;
    })
  }


  onAddressSelect(suggestion) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(suggestion) {
      object.attributes.address = suggestion.label;
      suggestion.gmaps && suggestion.gmaps.address_components && suggestion.gmaps.address_components.length > 0 && suggestion.gmaps.address_components.map((address_component) => {
        if(_.includes(address_component.types, "locality")) {
          object.attributes.city = address_component.long_name;
        }

        if(_.includes(address_component.types, "administrative_area_level_1")) {
          object.attributes.state = address_component.long_name;
        }
        
        if(_.includes(address_component.types, "postal_code")) {
          object.attributes.zip = address_component.long_name;
        }
      })
    } else {
      object.attributes.address = '';
      object.attributes.zip = "";
      object.attributes.state = "";
      object.attributes.city = "";
    }
  }

  onAddressClear(value) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(!value) {
      object.attributes.address = '';
    }
  }

  onExtraServiceSelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;

    let index = object.attributes.booking_service_type_extras.map(function(item) { return item.name; }).indexOf(selectedOptions.name);
    if(event.target.checked === true){
      object.attributes.booking_service_type_extras.push({service_type_extra_id:selectedOptions.id,name:selectedOptions.name,price:parseFloat(selectedOptions.price_cents/100)});
    }else{
        object.attributes.booking_service_type_extras[index].price = 0;
        object.attributes.booking_service_type_extras[index]._destroy = 1;
    }
    this.isServiceExtraChecked = key;
    this.calculateGrandtotal()
  }

  
  onFrequencySelect(event,selectedOptions,key) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    object.attributes.frequency_id = selectedOptions.id;
  }

  onPricingRangeSelectImage(event,selectedOptions,key) {
    
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        },
        serviceTypeStore: {
          serviceTypeDetail
        }
      }
    } = this;

    if(event.target.checked){
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.pricing_parameter_id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.pricing_parameter_id;
        object.attributes.booking_pricing_parameters[index].name = selectedOptions.label;
        object.attributes.booking_pricing_parameters[index].price = selectedOptions.price;
        object.attributes.booking_pricing_parameters[index].total_amount =  selectedOptions.price;
      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.pricing_parameter_id,name:selectedOptions.label,price:selectedOptions.price,total_amount:selectedOptions.price});
      }
      this.calculateGrandtotal()
    }
  }

  onPricingRangeSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(event.target.value != ''){
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].pricing_parameter_id = selectedOptions.id;
        object.attributes.booking_pricing_parameters[index].name = event.target.options[event.target.selectedIndex].text;
        object.attributes.booking_pricing_parameters[index].price = parseFloat(event.target.value);
        object.attributes.booking_pricing_parameters[index].total_amount = parseFloat(event.target.selectedIndex) * parseFloat(event.target.value);

      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat(event.target.value),total_amount:parseFloat(event.target.value)});
      
      }
      this.calculateGrandtotal()
    }
  }

  onPricingSelect(event,selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    if(event.target.value != ''){
      // Quantity is the number in the option label ("Tires x 4" is 4), as the server prices it.
      const quantity = flatOptionQuantity(flatOptionLabel(event));
      const amount = quantity * parseFloat((selectedOptions.price_cents/100));
      let index = object.attributes.booking_pricing_parameters.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if(index > -1){
        object.attributes.booking_pricing_parameters[index].name = event.target.value;
        object.attributes.booking_pricing_parameters[index].price = amount;
        object.attributes.booking_pricing_parameters[index].quantity = quantity;
        object.attributes.booking_pricing_parameters[index].total_amount = amount;
      }else{
        object.attributes.booking_pricing_parameters.push({pricing_parameter_id:selectedOptions.id,name:selectedOptions.name,quantity:quantity,total_amount:amount,price:amount});
      }
    } else {
      object.pricing_parameters = [];
    }
    this.calculateGrandtotal()
  }

  // The saved choice for a flat pricing parameter (e.g. "Tires x 3"), so its
  // select shows it. Saved bookings keep choices in booking_pricing_parameters,
  // new ones in pricing_parameters; both store the option text as `name`.
  selectedPricingLabel(pricing) {
    const { object } = this.props.bookingStore.booking;
    const attributes = (object && object.attributes) || {};
    // Option text has its whitespace collapsed by the browser (a name like
    // "Tires x " gives "Tires x  4" in code but "Tires x 4" as the option and
    // as the saved name), so compare and return the collapsed form.
    const tidy = (text) => String(text || '').replace(/\s+/g, ' ').trim();
    const saved = [...(attributes.booking_pricing_parameters || []), ...(attributes.pricing_parameters || [])]
      .map((item) => item && tidy(item.name));
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      const label = tidy(`${pricing.name} ${i}`);
      if (saved.includes(label)) return label;
    }
    return '';
  }

  pricingList = (pricing) => {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    let pricingToReturn = [];
    this.pricingParameterArray = [];
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      let label = `${pricing.name} ${i}`;
      let indexChecked = object.attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(label);
      if(indexChecked > -1){
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }else{
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }
    }
    return pricingToReturn;
  };

  pricingRangeList = (pricing) => {
    let {
      props: {
        pricingParameterStore,
        pricingParameterStore: {
          pricingParameterDetailUpdate: { 
            object
           }
        },
        bookingStore: {
          booking
        }
      }
    } = this;

    let pricingRangeToReturn = [];
    
    if(pricing.id){
      let index = pricing.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(pricing.id);
      if(index > -1){
        pricing.pricing_parameter_ranges.map((range) => {
          let label = `${range.label}`;
          let indexChecked = booking.object.attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(label);
          if(indexChecked > -1){
            pricingRangeToReturn.push(<option selected={'selected'} innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }else{
            pricingRangeToReturn.push(<option innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }
        });
      }
    }
    return pricingRangeToReturn;
  };

  handleStartDateChange(date) {
    let { object } = this.props.bookingStore.booking;
    if(date) {
      object.attributes.start_date = moment(date);
    }
  }

  onPaymentSelect = (event,payment,key) => {
    let { object } = this.props.bookingStore.booking;
    object.attributes.payment_method = payment.value;
  }

  onContactWayChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.contact_way = event.target.value;
  }

  onTimePeriodChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.start_project_expected_period = event.target.value;
  }

  onServiceTypeCategoryChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    this.props.viewStore.serviceTypeSearch.where.service_type_category_id = event.target.value;
    this.props.serviceTypeStore.loadServiceTypes() 
    object.attributes.service_type_category_id = event.target.value;
  }

  onServiceTypeChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail,
        princingRangeCombineArray
      }
    } = this.props;
    if(event.target.value !== "") {
      serviceTypeStore.princingRangeCombineArray = [];
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = event.target.value;
      serviceTypeStore.loadServiceTypeDetail({uuid:event.target.value})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  onServiceTypeSelect = (event,service,key) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore} = this.props;
    let { 
      serviceTypeStore: {
        serviceTypeDetail,
        princingRangeCombineArray
      },
      
    } = this.props;
    if(service.attributes.id !== "") {
      this.setState({
        isServiceTypeChecked: service.attributes.id
      });
      serviceTypeStore.princingRangeCombineArray = [];
      object.attributes.booking_service_type_extras = [];
      object.attributes.booking_pricing_parameters = [];
      object.attributes.service_type_id = service.attributes.id;
      serviceTypeStore.loadServiceTypeDetail({uuid:service.attributes.id})
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    }else{
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  calculateGrandtotal() {
    let { 
      bookingStore: {
        booking: {
          object
        }
      },
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;

    object.attributes.total = 0.0;
    
    // Adding Service type price in grand total
    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      object.attributes.total += serviceTypeDetail.object.attributes.rate;
    }
    // Adding pricing parameters flat to grand total
    if(object && object.attributes.booking_pricing_parameters && object.attributes.booking_pricing_parameters.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_pricing_parameters, 'price')
    }
    // Adding extra service types to grand total
    if(object && object.attributes.booking_service_type_extras && object.attributes.booking_service_type_extras.length > 0) {
      object.attributes.total += _.sumBy(object.attributes.booking_service_type_extras, 'price')
    }
  }

  updateBooking(status) {
    let {
      props: {
        store,
        bookingStore: {
          booking,
          booking: { 
            object
           }
        }
      }
    } = this;
    
    if(object.attributes.first_name === "" || object.attributes.first_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.last_name === "" || object.attributes.last_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.email === "" || object.attributes.email === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.phone === "" || object.attributes.phone === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.address === "" || object.attributes.address === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.city === "" || object.attributes.city === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.state === "" || object.attributes.state === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.zip === "" || object.attributes.zip === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
      return;
    }

    
    // Validation passed: show progress now, and remember the status so a
    // failed save doesn't leave the booking looking confirmed.
    const previousStatus = object.attributes.status;
    // Paid by card: confirming invoices the booking on its job (the card
    // payments move onto the invoice), so the job comes first.
    if(status === 'confirmed' && previousStatus !== 'confirmed' && object.attributes.card_paid && !object.attributes.invoice_id && !bookingJob(object.attributes)) {
      Toast.show({ icon: 'arrow-up', message: 'This booking is paid by card. Link a client and create the job first, then confirm: its invoice goes on the job.', intent: Intent.PRIMARY });
      const panel = document.getElementById('bk-client-job');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    booking.isLoading = true;
    object.attributes.status = status;
    object.attributes.booking_service_type_extras_attributes = object.attributes.booking_service_type_extras;
    object.attributes.booking_pricing_parameters_attributes = object.attributes.booking_pricing_parameters;
    object.attributes.booking_questions_attributes = object.attributes.booking_questions;

    this.props.bookingStore
      .updateBooking(object)
      .then(response => {
        Toast.show({
          icon: "thumbs-up",
          message: "Booking updated successfully!",
          intent: Intent.SUCCESS
        });
        if(response.data.data.attributes.status === 'confirmed'){
          console.log(response.data.data.attributes)
          if(!isRecurringBooking(response.data.data.attributes)){
            // One-time: the job needs a client and location, which the
            // "Client and job" panel collects before opening the job form.
            if (!bookingJob(response.data.data.attributes)) {
              Toast.show({ icon: 'arrow-up', message: 'Confirmed. Next, link a client and create the job.', intent: Intent.PRIMARY });
              const panel = document.getElementById('bk-client-job');
              if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }else if(!(response.data.data.attributes.service_agreements && response.data.data.attributes.service_agreements.length > 0)){
            // Recurring and no agreement yet: set one up.
            let {object } = this.props.serviceAgreementStore.persistServiceAgreement;
            let frequencyType = response.data.data.attributes.frequency.title;
            let frequencyTypeString = response.data.data.attributes.frequency.title.toUpperCase();
            let startDate = moment(response.data.data.attributes.start_date).format('YYYYMMDDTHHmmssz');
            object.reason_for_call = response.data.data.attributes.service_type.name;
            object.selectedServiceType = [{value: response.data.data.attributes.service_type_id,selected: true,label: response.data.data.attributes.service_type.name}];
            object.service_type_id = response.data.data.attributes.service_type_id;
            var string = '';
            if(frequencyType === 'Weekly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Bi-weekly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'WEEKLY'};INTERVAL=2;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Monthly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Quarterly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'MONTHLY'};INTERVAL=3;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Semi-annually'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=6;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Annually'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'YEARLY'};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Yearly'){
              string = `DTSTART:${startDate} RRULE:FREQ=${'YEARLY'};INTERVAL=1;BYMONTHDAY=1`;
            }
            if(frequencyType === 'Every other year'){
              string = `DTSTART:${startDate} RRULE:FREQ=${frequencyTypeString};INTERVAL=1;BYMONTHDAY=1`;
            }
            object.booking_id = response.data.data.attributes.id;
            object.rrule = string;
            this.props.jobStore.isServiceAgreement = true;
            this.props.store.isOpen = true;
          }
        }
        
      })
      .catch((error) => {
        object.attributes.status = previousStatus;
        booking.isLoading = false;
        const message = (error && error.response && error.response.data && (error.response.data.errors || error.response.data.error)) || 'Changes weren\'t saved. Try again.';
        Toast.show({ icon: 'warning-sign', message: Array.isArray(message) ? message.join(', ') : String(message), intent: Intent.DANGER });
      });
  }





  onChangeFile(event) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    var FileSize = event.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 10) {
      Toast.show({ icon: 'warning-sign', message: 'File size exceeds 10 MB!', intent: Intent.DANGER })
      return
    }
    this.props.bookingStore.uploadBookingAttachment(event.target.files[0], attributes.id)
      .then(this.onSuccessfullUploadAttachment.bind(this))
      .catch(this.onFailUploadAttachment.bind(this))
  }

  onSuccessfullUploadAttachment(response) {
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.booking_attachments.push(response.data.data.attributes);
  }

  onFailUploadAttachment(error) {
    this.props.bookingStore.showUploadAttachmentLoader = false;
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, failed to upload file!', intent: Intent.DANGER })
    }
  }

  removeAttachment(attachment) {
    let {
      bookingStore:{
        booking:{
          object: { attributes }
        }
      }
    } = this.props;
    this.props.bookingStore.removeAttachment(attachment, attributes.id)
  }

  renderPricingParameters(pricing_parameters, attributes) {
    if(!(pricing_parameters && pricing_parameters.length > 0)) {
      return null;
    }
    return (
      <div className="bk-pricing">
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing,pricingKey) => {
            if(pricing.pricing_type === 'flat'){
              return (
                <div className="bk-field" key={Math.random()}>
                  <FormGroup label={"Pricing"} labelFor="text-input">
                    <select
                      value={this.selectedPricingLabel(pricing)}
                      className='form-control'
                      placeholder={`Select ${pricing.name}`}
                      onChange={(event) => {this.onPricingSelect(event,pricing)} }
                    >
                      <option value="">Select one</option>
                    { this.pricingList(pricing)}
                    </select>
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
        <div className="bk-grid bk-grid--2">
        {
          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing) => {
            if(pricing.pricing_type === 'range'){
              var index = pricing.pricing_parameter_ranges.length === _.filter(pricing.pricing_parameter_ranges, function(obj) { return obj.image_url; }).length
              return (
                <div className={index === true ? "bk-field bk-field--full" : "bk-field"} key={Math.random()}>
                  <FormGroup
                    label={pricing.name}
                    labelFor="text-input"
                  >
                    {
                      index === true ?
                      <div className="bk-image-options">
                        {pricing.pricing_parameter_ranges.map((pricing_range,key) => {
                          let indexChecked = attributes.booking_pricing_parameters.map(function(item) { return item.name; }).indexOf(pricing_range.label);
                          var checked_id ='';
                          if(indexChecked > -1){
                            checked_id = pricing_range.id;
                          }
                          return (
                            <div className={`bk-image-option ${checked_id === pricing_range.id ? 'bk-image-option--active' : ''}`} key={pricing_range.id || key}>
                              <div className="bk-image-option__media">
                                <img src={pricing_range.image_url} alt="" />
                                <Radio type="radio" name="checkboxgroup"
                                  className="bk-image-option__radio"
                                  checked={checked_id === pricing_range.id ? true: false}
                                  onChange={(event) => {this.onPricingRangeSelectImage(event,pricing_range,key)} }
                                />
                              </div>
                              <span className="bk-image-option__label">{pricing_range.label}</span>
                            </div>
                          )
                        })}
                      </div>:
                      <select
                        className='form-control'
                        placeholder={`Select ${pricing.name}`}
                        onChange={(event) => {this.onPricingRangeSelect(event,pricing)} }
                        >
                        <option value="">Select one</option>
                        { this.pricingRangeList(pricing)}
                      </select>
                    }
                  </FormGroup>
                </div>
              )
            }
          })
        }
        </div>
      </div>
    );
  }

  get isAdmin() {
    const { viewStore } = this.props;
    const user = viewStore && viewStore.currentUser;
    return Boolean(user && user.attributes && user.attributes.role === 'admin');
  }

  render() {
    let {
      serviceTypeStore: {
        serviceType,
        serviceType:{
          objects
        },
        serviceTypeDetail,
      },
      bookingStore:{
        showUploadAttachmentLoader,
        booking:{
          object: {
            attributes
          },
          isLoading,
          isError
        }
      },
      questionGroupStore:{
        groups
      },
      serviceTypeCategoryStore:{
        serviceTypeCategories
      }
    } = this.props;

    let service_type_extra = [];
    let pricing_parameters = [];
    let frequency = [];
    let questions = [];

    if(serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      service_type_extra = serviceTypeDetail.object.attributes.service_type_extra
      pricing_parameters = serviceTypeDetail.object.attributes.pricing_parameters
      frequency = serviceTypeDetail.object.attributes.frequency
      questions = serviceTypeDetail.object.attributes.questions;
    }


    if (isLoading) {
      return(
        <div className="spinner-center">
          <Spinner />
        </div>
      )
    }

    if (isError) {
      return (
        <div className="bk-page">
          <div className="bk-page__missing">
            <DataList.Notice
              icon="search"
              title="Booking not found"
              message="It may have been deleted, or it belongs to another company account. Check the link, or go back to your booking requests."
              actions={[{ label: 'Back to booking requests', icon: 'arrow-left', primary: true, onClick: () => this.props.viewStore.bookings() }]}
            />
          </div>
        </div>
      );
    }

    // Display-only values for the header and the ticket.
    const serviceDetailAttributes = serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes;
    const selectedServiceType = attributes && attributes.service_type_id && _.find(objects, (service) => service.attributes && String(service.attributes.id) === String(attributes.service_type_id));
    const serviceColor = (selectedServiceType && selectedServiceType.attributes.color) || (serviceDetailAttributes && serviceDetailAttributes.color);
    const customerName = attributes ? [attributes.first_name, attributes.last_name].filter((part) => part && String(part).trim() !== '').join(' ') : '';
    const isConfirmed = attributes && attributes.status === 'confirmed';
    // The account's button text (cta_title) is written for customers; staff get the plain action.
    const confirmLabel = 'Confirm booking';
    const ticketGroups = [];
    if(attributes && attributes.booking_pricing_parameters && attributes.booking_pricing_parameters.length > 0) {
      ticketGroups.push({
        key: 'pricing',
        title: (attributes.pricing_title && attributes.pricing_title !== '') ? attributes.pricing_title : 'Pricing',
        lines: attributes.booking_pricing_parameters.map((parameter, index) => ({
          key: `pricing-${index}`,
          label: parameter.name,
          amount: currencyFormattedAmount(parameter.price)
        }))
      });
    }
    if(service_type_extra && service_type_extra.length > 0 && attributes && attributes.booking_service_type_extras) {
      ticketGroups.push({
        key: 'extras',
        title: 'Add-ons',
        lines: attributes.booking_service_type_extras
          .filter((ext_service) => ext_service._destroy !== 1)
          .map((ext_service, index) => ({
            key: `extra-${index}`,
            label: ext_service.name,
            amount: currencyFormattedAmount(ext_service.price)
          }))
      });
    }
    const showSchedule = (attributes && attributes.enable_visit_us === true) ||
      (attributes && attributes.enable_often_visit_us === true && frequency && frequency.length > 0);

    let step = 0;
    const nextStep = () => { step += 1; return step; };

    // Skip the Details section when it would be empty.
    const hasDetails = Boolean(
      hasGroupedQuestions(groups, questions)
      || (attributes && (attributes.booking_start_project_expected_period || attributes.booking_contact_way || attributes.booking_payment_method === true))
    );

    return (
      <div className="bk-page">
        <Helmet>
          <title>{`Booking | FieldNexus`}</title>
        </Helmet>
        <BookingPageHeader
          title={customerName || 'Booking'}
          status={attributes && attributes.status}
          meta={attributes && attributes.id
            ? [`Booking ${bookingReference(attributes.id)}`, attributes.created_at && `requested ${moment(attributes.created_at).format('MMM D, YYYY')}`].filter(Boolean).join(', ')
            : null}
        >
          <ShareBookingLink
            publicLink={attributes && attributes.public_link}
            confirmed={attributes && attributes.status === 'confirmed'}
          />
          <Button
            className="bk-btn"
            onClick={() => this.updateBooking('draft')}
            loading={isLoading}
          >
            Save
          </Button>
          <Button
            className="bk-btn"
            intent={Intent.PRIMARY}
            onClick={() => this.updateBooking('confirmed')}
            loading={isLoading}
            disabled={isConfirmed ? true : false}
          >
            {confirmLabel}
          </Button>
        </BookingPageHeader>
        <div className="bk-layout">
          <div className="bk-form-column">
          <div id="bk-client-job">
            <BookingClientJob
              attributes={attributes}
              onEditJob={bookingJob(attributes) ? () => this.startEditJob(bookingJob(attributes), attributes.id) : null}
            />
          </div>
          <BookingCardPayments
            attributes={attributes}
            isAdmin={this.isAdmin}
            onChanged={() => this.props.bookingStore.loadBooking({ uuid: attributes.id })}
          />
          <div className="bk-form">
            <BookingSection number={nextStep()} title="Contact" helper="Who the booking is for and how to reach them.">
              <div className="bk-grid bk-grid--2">
                <div className="bk-field">
                  <FormGroup
                    label={"First name"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='First name'
                      defaultValue={attributes && attributes.first_name}
                      onChange={(event) => {attributes.first_name = event.target.value;}}
                    />
                  </FormGroup>
                </div>
                <div className="bk-field">
                  <FormGroup
                    label={"Last name"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Last name'
                      defaultValue={attributes && attributes.last_name}
                      onChange={(event) => {attributes.last_name = event.target.value;}}
                    />
                  </FormGroup>
                </div>
                <div className="bk-field">
                  <FormGroup
                    label={"Email"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='email'
                      className='form-control'
                      placeholder='mail@domain.com'
                      defaultValue={attributes && attributes.email}
                      onChange={(event) => {attributes.email = event.target.value;}}
                    />
                  </FormGroup>
                </div>
                <div className="bk-field">
                  <FormGroup
                    label={"Phone"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Ex. 9876543210'
                      defaultValue={attributes && attributes.phone}
                      onChange={(event) => {attributes.phone = event.target.value;}}
                    />
                  </FormGroup>
                </div>
              </div>
            </BookingSection>

            <BookingSection number={nextStep()} title="Address" helper="Where the work happens.">
              <div className="bk-grid bk-grid--address">
                <div className="bk-field">
                  <FormGroup
                    label={"Address"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <GeoComplete
                      className='form-control geo-control'
                      placeholder="Search address"
                      initialValue={attributes && attributes.address}
                      onSuggestSelect={this.onAddressSelect.bind(this)}
                      onChange={this.onAddressClear.bind(this)}
                    />
                  </FormGroup>
                </div>
                <div className="bk-field">
                  <FormGroup
                    label={"Address line 2"}
                    labelFor="text-input"
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Suite, unit, floor'
                      defaultValue={attributes && attributes.suite}
                      onChange={(event) => {attributes.suite = event.target.value;}}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="bk-grid bk-grid--3">
                <div className="bk-field">
                  <FormGroup
                    label={"City"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='City'
                      value={(attributes && attributes.city) || ''}
                      onChange={(event) => {attributes.city = event.target.value;}}
                    />
                  </FormGroup>
                </div>
                <div className="bk-field">
                  <FormGroup
                    label={"State or province"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='State or province'
                      value={(attributes && attributes.state) || ''}
                      onChange={(event) => {attributes.state = event.target.value;}}
                    />
                  </FormGroup>
                </div>
                <div className="bk-field">
                  <FormGroup
                    label={"Zip or postal code"}
                    labelFor="text-input"
                    labelInfo={"*"}
                  >
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Ex. 0377'
                      value={(attributes && attributes.zip) || ''}
                      onChange={(event) => {attributes.zip = event.target.value;}}
                    />
                  </FormGroup>
                </div>
              </div>
            </BookingSection>

            <BookingSection
              number={nextStep()}
              title="Service"
              helper="The service requested, its pricing options and add-ons."
            >
              {
                serviceTypeCategories.objects &&
                <div className="bk-grid bk-grid--2">
                  <div className="bk-field">
                    <FormGroup label={'Service category'} labelFor="text-input" labelInfo={"*"}>
                      <div className="bk-select">
                        <select
                          className='form-control'
                          onChange={this.onServiceTypeCategoryChange.bind(this)}
                          value={attributes && attributes.service_type_category_id || ''}
                        >
                          <option value="">Select category</option>
                          { serviceTypeCategories.objects.map((category) => {
                              return(
                                <option value={category.attributes.id} key={category.attributes.id}>{category.attributes.name}</option>
                              )
                            })
                          }
                        </select>
                        { serviceTypeCategories.objects.length === 0 ?
                            <Spinner className="bk-select__spinner" size={Spinner.SIZE_SMALL} />
                            :
                            ""
                        }
                      </div>
                    </FormGroup>
                  </div>
                </div>
              }
              {
                attributes && attributes.display_service_type === 'Icon' ?
                <div className="bk-subsection">
                  { objects.length === 0 ?
                    <Spinner size={Spinner.SIZE_SMALL} />
                    :
                    ""
                  }
                  <div className="bk-cards">
                    { objects && objects.map((service,key) => {
                      if(service.attributes.display_on_booking_form) {
                        return (
                          <div
                            key={service.id}
                            className={service.id === attributes.service_type_id ? 'bk-card bk-card--active': 'bk-card'}
                            style={normalizeHex(service.attributes.color) ? { '--bk-card-accent': normalizeHex(service.attributes.color) } : undefined}
                          >
                            <span className="bk-card__icon">
                              {service.attributes.logo && <img src={service.attributes.logo} alt="" />}
                            </span>
                            <span className="bk-card__label">{service.attributes.name}</span>
                            <Radio label="" type="radio" name="service_type_id"
                              className="bk-card__control"
                              checked={service.id === attributes.service_type_id ? true: false}
                              onChange={(event) => {this.onServiceTypeSelect(event,service,key)} }
                            />
                          </div>
                          )
                        }
                      })
                    }
                  </div>
                  {this.renderPricingParameters(pricing_parameters, attributes)}
                </div>
                :
                <div className="bk-subsection">
                  <div className="bk-grid bk-grid--2">
                    <div className="bk-field">
                      <FormGroup label={'Service type'} labelFor="text-input" labelInfo={"*"}>
                        <ServiceTypeSelectWrap color={serviceColor}>
                          <select
                            className='form-control'
                            value={attributes && attributes.service_type_id || ''}
                            onChange={this.onServiceTypeChange.bind(this)}
                          >
                            <option value="">Select service</option>
                            { objects && objects.map((service) => {
                              if(service.attributes.display_on_booking_form) {
                                return(
                                  <option
                                    value={service.attributes.id}
                                    key={service.attributes.id}
                                  >
                                      {service.attributes.name}
                                  </option>
                                )
                              }
                              })
                            }
                          </select>
                          { objects.length === 0 ?
                            <Spinner className="bk-select__spinner" size={Spinner.SIZE_SMALL} />
                            :
                            ""
                          }
                        </ServiceTypeSelectWrap>
                      </FormGroup>
                    </div>
                  </div>
                  {this.renderPricingParameters(pricing_parameters, attributes)}
                </div>
              }

              {service_type_extra && service_type_extra.length > 0 && <div className="bk-subsection">
                <h3 className="bk-subsection__title">Add-ons</h3>
                <div className="bk-cards">
                  {
                    service_type_extra.map((extra,key) => {
                      indexChecked = attributes.booking_service_type_extras.map(function(item) { return item._destroy !== 1 ? item.service_type_extra_id : ""; }).indexOf(extra.id);
                      if(indexChecked > -1){
                        label = extra.id;
                      } else {
                        label = ""
                      }
                      return (
                        <div className={`bk-card ${label === extra.id ? 'bk-card--active' :''}`} key={Math.random()}>
                          <span className="bk-card__icon">
                            {extra.icon_file && extra.icon_file.thumb && extra.icon_file.thumb.url && <img src={extra.icon_file.thumb.url} alt="" />}
                          </span>
                          <span className="bk-card__label">{extra.name}</span>
                          <Checkbox label="" type="checkbox"
                            className="bk-card__control"
                            defaultChecked={label === extra.id ? true : false}
                            onChange={(event) => {this.onExtraServiceSelect(event,extra,key)} }
                          />
                        </div>
                      )
                    })
                  }
                </div>
              </div>}
            </BookingSection>

            {showSchedule &&
              <BookingSection number={nextStep()} title="Schedule" helper="When the visit happens and how often.">
                {attributes && attributes.enable_visit_us === true &&
                  <div className="bk-grid bk-grid--2">
                    <div className="bk-field booking_form_date">
                      <FormGroup
                        label={"Date and time"}
                        labelFor="text-input"
                        labelInfo={"*"}
                      >
                        <DateTimeInput
                          placeholder={'Date'}
                          defaultValue={attributes && attributes.start_date && moment(attributes.start_date)}
                          onChange={this.handleStartDateChange.bind(this)}
                        />
                      </FormGroup>
                    </div>
                  </div>
                }
                {attributes && attributes.enable_often_visit_us === true &&
                  <div>
                    {frequency && frequency.length > 0 && <div className="bk-field">
                      <span className="bk-label">How often</span>
                      <div className="bk-chips">
                        {
                          frequency.map((freqncy,frequencyKey) => {
                            if(attributes && attributes.frequency_id){
                              label = attributes.frequency_id;
                            }
                            return (
                              <button
                                type="button"
                                key={Math.random()}
                                onClick={(event) => {this.onFrequencySelect(event,freqncy,frequencyKey)} }
                                className={`bk-chip ${label == freqncy.id ? 'bk-chip--active' : ''}`}
                              >
                                {freqncy.title}
                              </button>
                            )
                          })
                        }
                      </div>
                    </div>}
                  </div>
                }
              </BookingSection>
            }

            {hasDetails && (
            <BookingSection number={nextStep()} title="Details" helper="Answers to the booking questions and how the customer wants to proceed.">
              {hasGroupedQuestions(groups, questions) && <div className="bk-questions">
                {
                  groups.objects.map(function(group) {
                    var isInGroup = questions.map(function(item) { return item.question_group_id; }).indexOf(group.id);
                    if(isInGroup > -1) {
                      return(
                        <div className="bk-question-group" key={group.id}>
                          <h3 className="bk-subsection__title">{group.attributes.question}</h3>
                          {questions && questions.length > 0 && questions.map((question, index) =>
                            {
                            indexChecked = attributes.booking_questions.map(function(item) { return item.question_id; }).indexOf(question.id);
                            if(indexChecked > -1){
                              label = question.id;
                              selectedAnswer = attributes.booking_questions[indexChecked].answer;
                            } else {
                              selectedAnswer = ""
                            }
                            if(group.attributes.id === question.question_group_id){
                            return(
                              <div className="bk-question" key={Math.random()}>
                                <span className="bk-label">{question.field_label}</span>
                                <div className="bk-question__answer">
                                  {question.field_type === "Checkbox" && <div>
                                    <RadioGroup inline={true} className="bk-radio-group" name="question_radio">
                                      {question.field_value && question.field_value.split(/\r?\n/).map((answer) => {
                                        return(
                                          <QuestionRadio
                                            inline= {true}
                                            bookingStatus={''}
                                            question={question}
                                            answer={answer}
                                            checkedValue={label}
                                            selectedAnswer={selectedAnswer}
                                          />
                                        )
                                      })}
                                    </RadioGroup>
                                    </div>}
                                    {question.field_type === "Dropdown"  && <div className="bk-question__control">
                                    <QuestionSelect
                                        inline= {true}
                                        question={question}
                                        bookingStatus={''}
                                        checkedValue={label}
                                        selectedAnswer={selectedAnswer}
                                      />
                                    </div>}
                                    {question.field_type === "Textbox"  && <div className="bk-question__control">
                                      <QuestionTextbox
                                        inline= {true}
                                        bookingStatus={''}
                                        question={question}
                                        selectedAnswer={selectedAnswer}
                                      />
                                    </div>}
                                </div>
                              </div>
                            )}})
                            }
                        </div>
                      )
                    }
                  })
                }
                </div>
              }
              <div className="bk-grid bk-grid--2">
                {attributes && attributes.booking_start_project_expected_period && (
                <div className="bk-field">
                  <FormGroup label={"How soon would you like to start this project?"} labelFor="text-input">
                    <select
                      className='form-control'
                      placeholder={`Select `}
                      onChange={this.onTimePeriodChange.bind(this)}
                      defaultValue={attributes && attributes.start_project_expected_period && attributes.start_project_expected_period}
                    >
                      <option value="">Select one</option>
                      { attributes && attributes.booking_start_project_expected_period && attributes.booking_start_project_expected_period.split(/\r?\n/).map((period) => {
                        var selected = '';
                        if(attributes.start_project_expected_period === period.split(":")[1]){
                          selected = 'selected'
                        }
                        return(
                          <option value={period.split(":")[1]}>{period.split(":")[0]}</option>
                        )})}
                    </select>
                  </FormGroup>
                </div>
                )}
                {attributes && attributes.booking_contact_way && (
                <div className="bk-field">
                  <FormGroup label={"What is the best way for us to contact you?"} labelFor="text-input">
                    <select
                      className='form-control'
                      placeholder={`Select `}
                      onChange={this.onContactWayChange.bind(this)}
                      defaultValue={attributes && attributes.contact_way && attributes.contact_way}
                    >
                      <option value="">Select one</option>
                      {attributes && attributes.booking_contact_way && attributes.booking_contact_way.split(/\r?\n/).map((way) => {
                        var selected = '';
                        if(attributes.contact_way === way.split(":")[1]){
                          selected = 'selected'
                        }
                        return(
                          <option value={way.split(":")[1]}>{way.split(":")[0]}</option>
                        )})}
                    </select>
                  </FormGroup>
                </div>
                )}
              </div>
              {attributes && attributes.booking_payment_method === true &&
                <div className="bk-field">
                  <span className="bk-label">Payment method</span>
                  <div className="bk-chips">
                    {
                      items.map((payment,paymentKey) => {
                        if(attributes && attributes.payment_method){
                          label = attributes.payment_method;
                        }
                        return (
                          <button
                            type="button"
                            key={Math.random()}
                            onClick={(event) => {this.onPaymentSelect(event,payment,paymentKey)} }
                            className={`bk-chip ${label === payment.value ? 'bk-chip--active' : ''}`}
                          >
                            {payment.label}
                          </button>
                        )
                      })
                    }
                  </div>
                </div>
              }
            </BookingSection>
            )}

            <BookingSection number={nextStep()} title="Attachments" helper="Photos or documents from the customer. Up to 10 MB each.">
              <BookingAttachments
                attachments={attributes && attributes.booking_attachments}
                uploading={showUploadAttachmentLoader}
                onChange={this.onChangeFile.bind(this)}
                onRemove={(attachment) => this.removeAttachment(attachment)}
              />
            </BookingSection>

            <BookingSection number={nextStep()} title="Notes" helper="Anything else the team should know.">
              <div className="bk-field">
                <textarea
                  type='text'
                  className='form-control'
                  placeholder='Type here...'
                  value={attributes && attributes.note || ''}
                  onChange={(event) => {attributes.note = event.target.value;}}
                />
              </div>
            </BookingSection>
          </div>
          </div>

          <div className="bk-aside">
            <BookingTicket
              date={attributes && attributes.start_date}
              customerName={customerName}
              contact={attributes && [attributes.email, attributes.phone].filter((part) => part).join(', ')}
              address={attributes && attributes.address ? joinAddress(attributes.address, attributes.suite, attributes.city, attributes.state, attributes.zip) : null}
              serviceName={serviceDetailAttributes ? serviceDetailAttributes.name : null}
              serviceDetail={serviceDetailAttributes ? `1 × ${currencyFormattedAmount(parseFloat(serviceDetailAttributes.rate))}` : null}
              serviceAmount={serviceDetailAttributes ? currencyFormattedAmount(serviceDetailAttributes.rate) : null}
              serviceColor={serviceColor}
              groups={ticketGroups}
              total={currencyFormattedAmount(attributes && attributes.total)}
            >
              <Button
                onClick={() => this.updateBooking('confirmed')}
                intent={Intent.PRIMARY}
                loading={isLoading}
                disabled={isConfirmed ? true : false}
              >
                {confirmLabel}
              </Button>
              <Button
                onClick={() => this.updateBooking('draft')}
                loading={isLoading}
              >
                Save
              </Button>
              {
                attributes && attributes.frequency && attributes.frequency.title === 'One Time' && attributes.scheduled_events.length > 0 ?
                <Button
                  onClick={() => this.startEditJob(attributes && attributes.scheduled_events.length > 0 && attributes.scheduled_events[0],attributes && attributes.id)}
                  icon="edit"
                  loading={isLoading}
                  >
                  Edit job
                </Button>
                :
                ''
              }
              {
                attributes && attributes.frequency && attributes.frequency.title != 'One Time' && attributes.service_agreements.length > 0 ?
                <Button
                  onClick={() => this.startEditServiceAgreement(attributes && attributes.service_agreements.length > 0 && attributes.service_agreements[0].id,attributes && attributes.id)}
                  icon="edit"
                  loading={isLoading}
                  >
                  Edit service agreement
                </Button>
                :
                ''
              }
              {
                isConfirmed ?
                <p className="bk-ticket__note">This booking is already confirmed.</p>
                : ""
              }
            </BookingTicket>
          </div>
        </div>
      </div>
    );
  }

};
export default BookingShowPage;
